import React, { useEffect, useRef } from "react";
import Shabash from "../../../../assets/svgs/gameplay/Shabash";
import StarLarge from "../../../../assets/svgs/gameplay/StarLarge";
import StarSmall from "../../../../assets/svgs/gameplay/StarSmall";
import styles from "./styles.module.css";
import { getWidth } from "../../../../utils/relativeSizes";
import clsx from "clsx";

interface CommonAnimationProps {
  children: React.ReactNode;
}

const CommonAnimation: React.FC<CommonAnimationProps> = ({children}) => {
  const commonDivRef = useRef<HTMLDivElement | null>(null);
  const starsRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const commonDivElement = commonDivRef.current;
    if (commonDivElement){
      commonDivElement.style.animation = `${styles.scaleAndFade} 3s linear infinite`;
    }

    starsRefs.current.forEach((star, index) => {
      if (star) {
        const delay = `${index * 0.1}s`;
        star.style.animation = `${styles.starScaleFade} 0.8s linear ${delay} infinite`;
      }
    });
  }, []);

  return (
    <div ref={commonDivRef} className={clsx(styles.shabashContainer, "flex alignItemCenter justifyContentCenter absolute")}>
      {/* <Shabash width={getWidth(125)} height={getWidth(46)} /> */}
      {children}
      <div className={clsx(styles.starContainer, styles.rightSide, "absolute")}>
        <div
          ref={(el) => (starsRefs.current[0] = el)}
          className={clsx(styles.star, styles.rightCenterStar, "absolute")}
        >
          <StarLarge width={getWidth(20)} height={getWidth(21)} />
        </div>
        <div
          ref={(el) => (starsRefs.current[1] = el)}
          className={clsx(styles.star, styles.rightUpperStar, "absolute")}
        >
          <StarSmall width={getWidth(8)} height={getWidth(8)} />
        </div>
        <div
          ref={(el) => (starsRefs.current[2] = el)}
          className={clsx(styles.star, styles.rightBottomStar, "absolute")}
        >
          <StarSmall width={getWidth(8)} height={getWidth(8)} />
        </div>
      </div>
      <div className={clsx(styles.starContainer, styles.leftSide, "absolute")}>
        <div
          ref={(el) => (starsRefs.current[3] = el)}
          className={clsx(styles.star, styles.leftCenterStar, "absolute")}
        >
          <StarLarge width={getWidth(20)} height={getWidth(21)} />
        </div>
        <div
          ref={(el) => (starsRefs.current[4] = el)}
          className={clsx(styles.star, styles.leftUpperStar, "absolute")}
        >
          <StarSmall width={getWidth(8)} height={getWidth(8)} />
        </div>
        <div
          ref={(el) => (starsRefs.current[5] = el)}
          className={clsx(styles.star, styles.leftBottomStar, "absolute")}
        >
          <StarSmall width={getWidth(8)} height={getWidth(8)} />
        </div>
      </div>
    </div>
  );
};

export default CommonAnimation;
